<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-tour-menutab [isEdit]="isEdit" [nameMenu]="nameMenu" [branchofficeSlug]="branchofficeSlug" [checkId]="checkId">
    </app-tour-menutab>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} tour
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>) - campos web (<i
              class="fab fa-quinscape text-primary"></i>)</p>
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-6">
                  <label>Nombre tour<span class="required"></span></label>
                  <input type="text" id="item_description" formControlName="description" required="true"
                    class="form-control" [autofocus]
                    [ngClass]="{'parsley-error': (submitted && f['description'].errors)}">
                  <div *ngIf="submitted && f['description'].errors">
                    <small class="text-danger" *ngIf="f['description'].errors['required']">Nombre es requerido</small>
                    <small class="text-danger" *ngIf="f['description'].errors['minlength']">Nombre Muy corto</small>
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>Ciudad salida<span class="required"></span></label>
                  <select class="form-control" id="citieTouristicSelected" formControlName="citietouristic_id" required>
                    <option value="">Seleccionar opción</option>
                    <option *ngFor="let item of citiestouristic" [value]="item.id">{{ item.description }}</option>
                  </select>
                  <div *ngIf="submitted && f['citietouristic_id'].errors">
                    <small class="text-danger" *ngIf="f['citietouristic_id'].errors['required']">Campo requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>Turno <span class="required"></span></label>
                  <select class="form-control" id="shiftTourSelected" formControlName="shift">
                    <option value="">Seleccionar opción</option>
                    <option *ngFor="let item of shifttours" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>

                <div class="form-group col-lg-2">
                  <label>
                    P. público
                    <span class="required"></span>
                  </label>
                  <div class="input-group">
                    <span class="input-group-prepend"><span
                        class="input-group-text">{{toolsService.momeySol()}}</span></span>
                    <input type="text" class="form-control bold" formControlName="price_public" required numeric
                      decimals="2" onclick="click_input(this)"
                      [ngClass]="{'parsley-error': (submitted && f['price_public'].errors)}">
                    <div *ngIf="submitted && f['price_public'].errors">
                      <small class="text-danger" *ngIf="f['price_public'].errors['required']">Nombre es
                        requerido</small>
                    </div>
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label>
                    P. corporativo
                    <span class="required"></span>
                  </label>
                  <div class="input-group">
                    <span class="input-group-prepend"><span
                        class="input-group-text">{{toolsService.momeySol()}}</span></span>
                    <input type="text" class="form-control bold" formControlName="price_corporate" required numeric
                      decimals="2" onclick="click_input(this)"
                      [ngClass]="{'parsley-error': (submitted && f['price_corporate'].errors)}">
                    <div *ngIf="submitted && f['price_corporate'].errors">
                      <small class="text-danger" *ngIf="f['price_corporate'].errors['required']">Nombre es
                        requerido</small>
                    </div>
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label>
                    P. paquete tours
                    <span class="required"></span>
                  </label>
                  <div class="input-group">
                    <span class="input-group-prepend"><span
                        class="input-group-text">{{toolsService.momeySol()}}</span></span>
                    <input type="text" class="form-control bold" formControlName="price_package" required numeric
                      decimals="2" onclick="click_input(this)"
                      [ngClass]="{'parsley-error': (submitted && f['price_package'].errors)}">
                    <div *ngIf="submitted && f['price_package'].errors">
                      <small class="text-danger" *ngIf="f['price_package'].errors['required']">Nombre es
                        requerido</small>
                    </div>
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label>
                    <i class="fab fa-quinscape text-primary m-r-5"></i> P. página web
                    <span class="required"></span>
                  </label>
                  <div class="input-group">
                    <span class="input-group-prepend"><span
                        class="input-group-text">{{toolsService.momeySol()}}</span></span>
                    <input type="text" class="form-control bold" formControlName="price_web" required numeric
                      decimals="2" onclick="click_input(this)"
                      [ngClass]="{'parsley-error': (submitted && f['price_web'].errors)}">
                    <div *ngIf="submitted && f['price_web'].errors">
                      <small class="text-danger" *ngIf="f['price_web'].errors['required']">Nombre es requerido</small>
                    </div>
                  </div>
                </div>
                <div class="form-group col-lg-4">
                  <label><i class="fab fa-quinscape text-primary m-r-5"></i>Detalle duración</label>
                  <input type="text" id="object_time_duration" placeholder="1 hora y..." class="form-control"
                    formControlName="time_duration">
                </div>
                <!-- <div class="form-group col-lg-6">
                  <label>Seleccionar imagen itinerario </label>
                  <ng-container *ngIf="item.value.url_image_itinerary != null">
                    <div class="row col-lg-12 col-12 p-0">
                      <div class="col-lg-6 col-12">
                        <a target="_blank" href="tenants/{{item.value.url_image_itinerary}}"
                          class="btn btn-outline-primary pointer w-100">Formato PDF cargado <i
                            class="far fa-file-pdf m-l-5"></i></a>
                      </div>
                      <div class="form-group col-lg-6 col-6">
                        <button (click)="removeFileItinerary()" class="btn btn-outline-danger pointer w-100">
                          Quitar imagen <i class="fas fa-minus-circle"></i>
                        </button>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="item.value.url_image_itinerary == null">
                    <input id="file_pdf" type="file" (change)="onFileItinerarySelected($event)"
                      accept=".png, .jpg, .jpeg" />
                  </ng-container>
                </div> -->
                <div class="form-group col-lg-6">
                  <label>Seleccionar Formato PDF </label>
                  <ng-container *ngIf="item.value.url_file != null">
                    <div class="row col-lg-12 col-12 p-0">
                      <div class="col-lg-6 col-6">
                        <a target="_blank" href="tenants/{{item.value.url_file}}"
                          class="btn btn-outline-primary pointer w-100">Formato PDF cargado <i
                            class="far fa-file-pdf m-l-5"></i></a>
                      </div>
                      <div class="form-group col-lg-6 col-12">
                        <button (click)="removeFilePdf()" class="btn btn-outline-danger pointer w-100">
                          Quitar pdf <i class="fas fa-minus-circle"></i>
                        </button>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="item.value.url_file == null">
                    <input id="file_pdf" type="file" (change)="onFileSelected($event)" accept="application/pdf" />
                  </ng-container>
                </div>
                <div class="form-group col-lg-3">
                  <div class="custom-control custom-checkbox float-left">
                    <input type="checkbox" class="custom-control-input" formControlName="is_show_web"
                      id="is_show_web">
                    <label class="custom-control-label p-t-3" for="is_show_web">¿Se muestra en la web?</label>
                  </div>
                </div>
                <!-- <div class="col-lg-6"></div> -->
                <div class="form-group col-lg-6 m-t-15">
                  <label><i class="fab fa-quinscape text-primary m-r-5"></i>Incluye (Resumen de lo que
                    incluye)</label>
                  <ckeditor formControlName="include"></ckeditor>
                </div>

                <div class="form-group col-lg-6 m-t-15">
                  <label><i class="fab fa-quinscape text-primary m-r-5"></i>Programa turístico
                    (itinerario, actividades, recomendaciones)</label>
                  <ckeditor formControlName="tourist_program"></ckeditor>
                </div>
                <!-- <div class="form-group col-lg-6">
                  <label>Presentación (Datos históricos, leyendas, ubicación)</label>
                  <ckeditor formControlName="comment"></ckeditor>
                </div> -->
              </div>
            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary waves-effect waves-light" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  Guardar
                  <ng-container *ngIf="isEdit">
                    Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>